export const isEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());

export const isIndianPhone = (value) => {
  const digits = String(value || '').replace(/\D/g, '');
  return /^[6-9]\d{9}$/.test(digits) || /^91[6-9]\d{9}$/.test(digits);
};

export const isIndianPostalCode = (value) => /^[1-9]\d{5}$/.test(String(value || '').trim());

export function validateRegistration(values = {}) {
  const errors = {};
  if (String(values.firstName || '').trim().length < 2) errors.firstName = 'Enter a valid first name.';
  if (!String(values.lastName || '').trim()) errors.lastName = 'Enter a valid last name.';
  if (!isEmail(values.email)) errors.email = 'Enter a valid email address.';
  if (!isIndianPhone(values.phone)) errors.phone = 'Enter a valid 10-digit Indian mobile number.';
  const password = String(values.password || '');
  if (password.length < 10 || password.length > 128 || !/[a-z]/.test(password) || !/[A-Z]/.test(password) || !/\d/.test(password)) {
    errors.password = 'Use 10–128 characters with uppercase, lowercase and a number.';
  }
  if (password !== values.confirmPassword) errors.confirmPassword = 'Passwords do not match.';
  return errors;
}

export function validateLogin(values = {}) {
  const errors = {};
  if (!isEmail(values.email)) errors.email = 'Enter a valid email address.';
  if (!String(values.password || '')) errors.password = 'Enter your password.';
  return errors;
}

export function validatePasswordReset(values = {}, includeCode = false) {
  const errors = {};
  if (!isEmail(values.email)) errors.email = 'Enter a valid email address.';
  if (!includeCode) return errors;
  if (!/^\d{6}$/.test(String(values.code || ''))) errors.code = 'Enter the 6-digit reset code.';
  const password = String(values.password || '');
  if (password.length < 10 || password.length > 128 || !/[a-z]/.test(password) || !/[A-Z]/.test(password) || !/\d/.test(password)) errors.password = 'Use 10–128 characters with uppercase, lowercase and a number.';
  if (password !== values.confirmPassword) errors.confirmPassword = 'Passwords do not match.';
  return errors;
}

export function validateDeliveryAddress(address = {}) {
  if (String(address.recipientName || '').trim().length < 2) return 'Enter the recipient name.';
  if (!isEmail(address.email)) return 'Enter a valid delivery email address.';
  if (!isIndianPhone(address.phone)) return 'Enter a valid 10-digit Indian delivery phone.';
  if (!String(address.addressLine1 || '').trim() || !String(address.city || '').trim() || !String(address.state || '').trim()) return 'Complete the delivery address.';
  if (String(address.country || '').trim().toLowerCase() === 'india' && !isIndianPostalCode(address.postalCode)) return 'Enter a valid 6-digit Indian PIN code.';
  return '';
}

export function validateTracking(values = {}) {
  if (!String(values.orderNumber || '').trim()) return 'Enter your order number.';
  if (!isIndianPhone(values.phone)) return 'Enter the 10-digit delivery phone number.';
  return '';
}
